import { useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import "./InspectionOfficerPhoto.css";
import axios from "axios";
const InspectionOfficerPhoto = () => {
  const location = useLocation();
  const [row, setRow] = useState(null);
  const [selectedCoords, setSelectedCoords] = useState(null);
  const [remarks, setRemarks] = useState(""); // ✅ Track remarks
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const modalRef = useRef(null);
  const modalImageRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (localPath) => {
    if (modalRef.current && modalImageRef.current) {
      modalRef.current.style.display = "block";
      modalImageRef.current.src = localPath;
    }
  };

  const closeModal = () => {
    if (modalRef.current) {
      modalRef.current.style.display = "none";
    }
  };

  useEffect(() => {
    const storedData = localStorage.getItem("inspectionOfficerData");
    if (storedData) {
      setRow(JSON.parse(storedData));
    }
  }, []);

  const [userInfo, setUserInfo] = useState({
    // displayName: '',
    // empId: ''
    fullName: '',
    employeeId: '',
    id: '',
    username: '',
  });
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user'));
    const loginTime = localStorage.getItem('loginTime');

    if (userData) {
      // Extract the first name from fullName (only the first word)
      const firstName = userData.fullName.split(' ')[0];

      // Set the state with firstName and employeeId
      setUserInfo({
        fullName: firstName,  // Only first name is considered
        employeeId: userData.employeeId,
        id: userData.id,
        loginUserName: userData.username,
      });
      setIsLoggedIn(true);
      // setLastLoginDateTime(`Last Login: ${format(new Date(loginTime), 'dd-MM-yyyy | hh:mm:ss a')}`);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  if (!row) {
    return <p className="no-data">No data found. Please go back to the table.</p>;
  }
  const capitalizeWords = (str) => {
    if (!str || typeof str !== "string") return "";
    return str
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };


  const getLocalImagePath = (imageUrl) => {
    if (!imageUrl) {
      return "https://via.placeholder.com/400x300?text=No+Image";
    }
    const externalBaseUrl = "https://parakhfiles.s3.ap-south-1.amazonaws.com";
    const localBasePath = "https://d2qyrr1tl2df8g.cloudfront.net";
    if (imageUrl.startsWith(externalBaseUrl)) {
      const relativePath = imageUrl.substring(externalBaseUrl.length);
      return localBasePath + relativePath;
    }
    return imageUrl;
  };
  const token = `${process.env.REACT_APP_AUTH_TOKEN}`;
  const baseUrl = `${process.env.REACT_APP_GODOWN_API_URL}/api`;
  // ✅ Handle Submit
  const handleSubmit = () => {
    // if (!selectedCoords?.lat || !selectedCoords?.long) {
    //   alert("Please select coordinates before submitting.");
    //   return;
    // }

    const payload = {
      userId: userInfo.id, // ✅ logged-in user's ID
      fpsId: row.fpsId,
      remarks: remarks.trim() || null,
      selectedType: selectedCoords?.type || "Decision not yet",

      // Always send Master Data coords
      masterLatitude: row.fpsLat || null,
      masterLongitude: row.fpsLong || null,

      // Always send Inspection Data coords (Board OR Officer)
      inspectionLatitude: row.boardLat || row.officerLat || null,
      inspectionLongitude: row.boardLong || row.officerLong || null,
    };

    console.log("Payload to send:", payload);

    axios.post(
      `${baseUrl}/update-fps-lat-long`,
      payload, // ✅ This is the request body
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then(() => {
        alert("Updated Latitude and Longitude successfully!");
      })
      .catch((error) => {
        console.error("Error adding Latitude and Longitude:", error);
        alert("Error adding Latitude and Longitude: " + error.message);
      });

  };


  return (
    <div className="photo-page">
      <h2 className="page-title">Inspection Data</h2>

      {/* FPS ID & Last Inspection Date */}
      <div className="distance-Insp-added">
        <div className="fps-id-based">
          <div>FPS ID : </div>
          <div>{row.fpsId}</div>
        </div>
        <div className="fps-based-id">
          <div>Last Inspection Date :</div>
          <div>
            {row.latestDate
              ? new Date(row.latestDate).toLocaleDateString("en-GB").replace(/\//g, "-")
              : "-"}
          </div>
        </div>
      </div>

      {/* Licence Number & Dealer Name */}
      <div className="distance-Insp-added">
        <div className="fps-id-based-1">
          <div>Licence Number : </div>
          <div>{row.licenceNumber}</div>
        </div>
        <div className="fps-based-id">
          <div>Dealer Name :</div>
          <div>{row.dealerName ? capitalizeWords(row.dealerName) : "-"}</div>

        </div>
      </div>
      {/* images */}
      <div className="photo-images-con">
        <table>
          <thead>
            <tr>
              {row.boardLat && row.boardLong && row.boardUrl ? (
                <th>Board Image</th>
              ) : row.shopLat && row.shopUrl ? (
                <th>Shop Image</th>
              ) : null}
              {row.officerUrl && <th>Officer Image</th>}
            </tr>
          </thead>

          <tbody>
            <tr>
              {(row.boardLat && row.boardLong && row.boardUrl) ? (
                <td>
                  <img
                    src={getLocalImagePath(row.boardUrl)}
                    alt="Board"
                    className="photo-img-1"
                    style={{ cursor: "pointer", maxWidth: "100%", height: "auto" }}
                    onClick={() => openModal(getLocalImagePath(row.boardUrl))}
                  />
                </td>
              ) : row.shopLat && row.shopUrl ? (
                <td>
                  <img
                    src={getLocalImagePath(row.shopUrl)}
                    alt="Shop"
                    className="photo-img-1"
                    style={{ cursor: "pointer", maxWidth: "100%", height: "auto" }}
                    onClick={() => openModal(getLocalImagePath(row.shopUrl))}
                  />
                </td>
              ) : null}
              <td>
                <img
                  src={getLocalImagePath(row.officerUrl)}
                  alt="Inspection Officer"
                  className="photo-img-2"
                  style={{ cursor: "pointer", maxWidth: "100%", height: "auto" }}
                  onClick={() => openModal(getLocalImagePath(row.officerUrl))}
                />
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      {/* Master Data & Inspection Data Tables */}
      <div className="distance-Insp-added">
        <div className="master-data">
          <table>
            <thead>
              <tr><th colSpan={2}><h3>Master Data</h3></th></tr>
              <tr><th>Latitude</th><th>Longitude</th></tr>
            </thead>
            <tbody>
              <tr>
                <td>{row.fpsLat || "-"}</td>
                <td>{row.fpsLong || "-"}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="inspection-data">
          <table>
            <thead>
              <tr><th colSpan={2}><h3>Inspection Data</h3></th></tr>
            </thead>
            <thead>
              <tr>
                {/* <th colSpan={2}><h3>Board Data</h3></th>
                <th colSpan={2}><h3>Officer Data</h3></th> */}
              </tr>
              <tr><th>Latitude</th><th>Longitude</th>
                {/* <th>Latitude</th><th>Longitude</th> */}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{row.boardLat || row.officerLat}</td>
                <td>{row.boardLong || row.officerLong}</td>
                {/* <td>{row.officerLat ||"-"}</td>
                <td>{ row.officerLong ||"-"}</td> */}
              </tr>

            </tbody>
          </table>
        </div>
      </div>

      {/* Distance */}
      <div className="distance-Insp-distance">
        <div className="distance-data">
          <table>
            <thead>
              <tr><th colSpan={2}>Distance between Master and Inspection Data Lat-Long</th></tr>
              <tr><th>Distance (mtrs)</th><th>Distance (kms)</th></tr>
            </thead>
            <tbody>
              <tr>
                <td>{row.distanceMtrs ? row.distanceMtrs.toFixed(0) : 0}</td>
                <td>{row.distanceKms ? row.distanceKms.toFixed(2) : 0}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Selection */}
      <div className="selection-section">
        <div className="slection-coordinates">Correct Coordinates</div>
        <div className="selection-options">
            {row.fpsLat !== null && row.fpsLong !== null && (
          <label className="option-label">
            <input
              type="radio"
              name="coords"
              value="master"
              onChange={() =>
                setSelectedCoords({
                  lat: row.fpsLat,
                  long: row.fpsLong,
                  type: "Master Data",
                })
              }
            />
            <span>Master Data</span>
          </label>
            )}
          <label className="option-label">
            <input
              type="radio"
              name="coords"
              value="inspection"
              onChange={() =>
                setSelectedCoords({
                  lat: row.boardLat || row.officerLat,
                  long: row.boardLong || row.officerLong,
                  type: "Inspection Officer",
                })
              }
            />
            <span>Inspection Data</span>
          </label>

          <label className="option-label">
            <input
              type="radio"
              name="coords"
              value="decision"
              onChange={() => setSelectedCoords(null)} // Decision not taken
            />
            <span>Decision not taken</span>
          </label>
        </div>

        <br />
        <div className="remarks-text-div">
          <label className="remarks-text">Remarks  </label>
          <textarea
            className="remarks-input"
            placeholder="Enter Remarks"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />
        </div>

        {/* Buttons */}
        <div className="bottons-types">
          <button
            className="photo-submit"
            type="button"
            onClick={() => window.close()}
          >
            CANCEL
          </button>
          <button
            className="photo-submit"
            type="button"
            onClick={handleSubmit}
          >
            SUBMIT
          </button>
        </div>
      </div>

      {/* Modal */}
      <div id="imageModal" className="modal" ref={modalRef}>
        <span className="close" onClick={closeModal}>&times;</span>
        <img className="modal-content" ref={modalImageRef} />
      </div>
    </div>
  );
};

export default InspectionOfficerPhoto;
